import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard implements CanActivate {
  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const feature = route.data.feature as string;
    if (!feature) {
      console.error('Feature flag not provided');
      this.router.navigate(['/not-found']);
      return false;
    }
    if (this.featureFlagService.isEnabled(feature)) {
      return true;
    } else {
      this.router.navigate(['/not-found']);
      return false;
    }
  }
}
